import type { EventCapturer } from '#src/analytics/analytics_event.ts';
import type { DeviceMemoryStore } from '#src/groups/device_memory/device_memory_store.ts';
import type { GroupClient } from '#src/groups/http/group_client.ts';
import type { ErrorService } from '#src/telemetry/errors/error_service.ts';
import type { WishlistClient } from '#src/wishlists/http/wishlist_client.ts';
import { invariant } from '@packages/primitives/invariant';
import { createContext, use } from 'react';

export interface ServiceContainer {
  captureEvent: EventCapturer;
  errorService: ErrorService;
  groupClient: GroupClient;
  deviceMemoryStore: DeviceMemoryStore;
  wishlistClient: WishlistClient;
}

export const ServicesContext = createContext<ServiceContainer | null>(null);
export const ServicesProvider = ServicesContext.Provider;

export const useServices = (): ServiceContainer => {
  const services = use(ServicesContext);
  invariant(services != null, 'Service container must be set with ServicesProvider.');
  return services;
};
